/* eslint-disable */
export default {
  matched: 'Matched',
  other: 'Other',
  associated: 'Associated',
  foundFromServer: 'Found from {appName}',
  recently: 'Recent',
  additionalLabelAccount: 'Account: {displayName}',
  additionalLabelContact: 'Contact: {displayName}',
  notFound: 'N/A',
} as const;

// @key: @#@"matched"@#@ @source: @#@"Matched"@#@
// @key: @#@"other"@#@ @source: @#@"Other"@#@
// @key: @#@"associated"@#@ @source: @#@"Associated"@#@
// @key: @#@"foundFromServer"@#@ @source: @#@"Found from {appName}"@#@
// @key: @#@"recently"@#@ @source: @#@"Recent"@#@
// @key: @#@"additionalLabelAccount"@#@ @source: @#@"Account: {displayName}"@#@
// @key: @#@"additionalLabelContact"@#@ @source: @#@"Contact: {displayName}"@#@
// @key: @#@"notFound"@#@ @source: @#@"N/A"@#@
